module.exports = __webpack_public_path__ + "assets/img/00010.55bbd172.png";